import { ReactComponent } from './house-car-xl.svg';
export const HouseCarIconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=house-car-xl.js.map